import { Toast } from './Toast';

export default Toast;
